export const mmLanguageConstants = {
    menuApiRoute: "api/_localization",
    translationGroup: "_localization"
}
